module.exports = __webpack_public_path__ + "fonts/fa-solid-900.18dd0b2.woff2";